import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import React from 'react';

import * as GQL from '~/graphql/generated/client';

interface ChampionIconProps {
  projectType?: GQL.ProjectType;
  onSetChampion?: () => void;
}

const ChampionIcon: React.FC<ChampionIconProps> = ({
  projectType,
  onSetChampion,
}) => {
  if (
    projectType !== GQL.ProjectType.ModelCandidate &&
    projectType !== GQL.ProjectType.ModelChampion
  ) {
    return null;
  }

  return projectType === GQL.ProjectType.ModelChampion ? (
    <MilitaryTechIcon className="champion-icon active" />
  ) : (
    <MilitaryTechIcon
      className="champion-icon"
      onClick={(e) => {
        e.stopPropagation();
        onSetChampion?.();
      }}
    />
  );
};

export default ChampionIcon;
